import { render, staticRenderFns } from "./RegistracijaSudionikaBase.vue?vue&type=template&id=0cda0443&scoped=true&"
import script from "./RegistracijaSudionikaBase.vue?vue&type=script&lang=js&"
export * from "./RegistracijaSudionikaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cda0443",
  null
  
)

export default component.exports